export default "__VITE_ASSET__FAOJmck$__"